"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUser = exports.packageUserDataForTokens = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _react = _interopRequireDefault(require("react"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

// Format user data so token plugin knows what to do with it
var packageUserDataForTokens = (0, _memoize.default)(function (users) {
  return users.data.map(function (user) {
    var name = user.get('firstName') && user.get('lastName') ? user.get('firstName') + " " + user.get('lastName') : '';
    var email = user.get('email');
    return {
      avatar: _react.default.createElement(_UIAvatar.default, {
        lookup: {
          type: 'hubSpotUserEmail',
          primaryIdentifier: email
        },
        size: "xs"
      }),
      text: name || email,
      dropdownText: name ? name + " (" + email + ")" : email,
      value: user.get('id'),
      searchText: name ? name + " " + email : email
    };
  }).toArray();
}, function (users) {
  return users.hashCode();
});
exports.packageUserDataForTokens = packageUserDataForTokens;

var parseUser = function parseUser(id, users) {
  var user = users.data.get(id);

  if (!user) {
    return {
      firstName: _I18n.default.text('composer-lib.defaultUser.firstName'),
      id: id,
      lastName: _I18n.default.text('composer-lib.defaultUser.lastName')
    };
  }

  return user;
};

exports.parseUser = parseUser;